// extracted by mini-css-extract-plugin
export default {"wrapper":"menu-list_wrapper__2NBSl","opacity-transition":"menu-list_opacity-transition__dOQx0"};